// Take a peek before adding routes:
// https://github.com/pillarjs/path-to-regexp/tree/v1.7.0
export const uuid =
    '[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}';
